<template>
  <div class="large-3 columns">
    <div class="filters-wrapper mb-7">
      <p class="clear-filters">
        <a href="#" @click.prevent="clearFilters" :class="clearFilterCssClasses">
          Clear filters <span class="count ml-2">{{selectedFilterCount}}</span>
        </a>
      </p>

      <div v-for="filter in filters" :key="filter.paramName">
        <component :is="filter.component" :filter="filter" class="mb-6"></component>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed, defineAsyncComponent } from 'vue';
  import { useStore } from 'vuex';

  const store = useStore();

  const filters = computed(() => store.getters["filters/getFilters"]);

  const selectedFilterCount = computed(() => store.getters["filters/selectedFilterItemCount"]);

  const clearFilters = () => {
    if (selectedFilterCount.value == 0) return;

    store.dispatch("filters/clearFilters");
    store.dispatch("hackathons/search");
  }

  const clearFilterCssClasses = computed(() => {
    return { 'is-faded': selectedFilterCount.value == 0 }
  });
</script>

<style scope lang="scss">
  .count {
    background: #eaeaea;
    padding: 2px 6px;
    border-radius: 3px;
    font-size: 0.875rem;
  }

  .filters-wrapper {
    padding-right: 2rem;
  }

  .clear-filters {
    line-height: 42px;
  }

  .is-faded {
    &, &:hover, &:focus {
      color: #9CAEB2;
      cursor: default;
    }
  }
</style>
